import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import { TextBox, CheckBox, SelectBox, TextArea, NumberBox, DateBox } from 'devextreme-react';

import AntProcessingButton from './AntProcessingButton';
import AntStepperBox from './AntStepperBox';

export default forwardRef(function (props, ref) {
    const [mainValue, setMainValue] = useState(props.defaultValue ? props.defaultValue : 1);

    useImperativeHandle(
        ref,
        () => ({
            increment: () => {
                setMainValue((value) => (Number(value) || 0) + 1);
            }
        }),
        []
    );

    useEffect(() => {
        setMainValue(props.defaultValue ? props.defaultValue : 1);
    }, [props.defaultValue]);

    const handleOnClick = useCallback(
        (e, done) => {
            if (props.onClick) return props.onClick({ ...e, stepValue: mainValue }, done);
        },
        [props.onClick, mainValue]
    );

    const onEnterKey = useCallback(
        (e) => {
            let value = e.component?.option('value');
            setMainValue(value);

            if (props.onClick)
                props.onClick({
                    actionId: props.actionId,
                    action: props.action,
                    data: props.data,
                    stepValue: value
                });
        },
        [props.onClick, props.actionId, props.action, props.data]
    );

    const onValueChanged = useCallback((e) => {
        if (isNaN(e.value)) setMainValue(1);
        else setMainValue(e.value);
    }, []);

    var decDigit = props.decimalDigit !== undefined && props.decimalDigit !== null ? props.decimalDigit : 2;
    var strFormat = decDigit > 0 ? '#,##0.' + String('#').repeat(decDigit) : '#,##0';
    if (props.action?.unitType === 'Km') strFormat = strFormat + ' Km';

    return (
        <React.Fragment>
            <AntStepperBox
                alignment={'center'}
                format={strFormat}
                style={{ marginBottom: 5, paddingLeft: 7, paddingRight: 7 }}
                defaultValue={mainValue}
                onValueChanged={onValueChanged}
                onEnterKey={onEnterKey}
            />
            <AntProcessingButton {...props} onClick={handleOnClick} />
        </React.Fragment>
    );
});
